module.exports = require('./helpers/bundle-url').getBundleURL('gfGbX') + "Smith_Jennifer.a86a5470.jpg";